// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form can be used to remove activated devices.
  </span>
</div>

  <h2 class="section-header">Please confirm the following:</h2>
  <form name="\$ctrl.form">
    <table class="table">
      <tbody>
        <tr>
          <td>Usernames:</td>
          <td>
            <selectize required
                       ng-model="\$ctrl.usernames"
                       config="\$ctrl.usernamesConfig">
            </selectize>
          </td>
        </tr>
      </tbody>
    </table>

    <div ng-if="\$ctrl.result">
      <h2 class="section-header">Summary</h2>
      <dynamic-list
        columns="\$ctrl.resultColumns"
        data="\$ctrl.result"
        list-type="'NORMAL'"
      >

    </div>

    <div class="flex-end">
      <button
        type="button"
        class="btn btn-success"
        ng-disabled="\$ctrl.form.\$invalid"
        ng-click="\$ctrl.remove()">
        Remove
      </button>
    </div>
  </form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/remove-active-devices/remove-active-devices.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;